import React, { useContext, useReducer } from 'react';
import LoaderReducer, { LoaderAction, LoaderState } from '../api/LoaderReducer';
import { ContextProps } from '../types/ContextProps';

type LoaderContextType = {
    loaderState: LoaderState;
    dispatchLoaderAction: React.Dispatch<LoaderAction>;
};

export const LoaderContext = React.createContext<LoaderContextType>(undefined!);

export const LoaderContextProvider = ({ children }: ContextProps) => {
    const [loaderState, dispatchLoaderAction] = useReducer(LoaderReducer, { loaderDetails: [] });

    return (
        <LoaderContext.Provider
            value={{
                loaderState,
                dispatchLoaderAction,
            }}
        >
            {children}
        </LoaderContext.Provider>
    );
};

export const useLoaderStore = () => useContext(LoaderContext);
